import Base from './Base.js';

export default class SessionCounter extends Base {
  static get _path() {
    return 'es6/src/storage/models/sessionCounter/Counter';
  }

  static get _defaultValue() {
    return 0;
  }
}
